<template>
  <div class="view" v-if="canEdit || canDelete" v-cloak>
    <card :title="title" id="shift-list">
      <agro-filter-container :new-object="newObject" :title='$t("common.create_new", { name: title })'>
        <s-c-shift-filters ref="filters" @onFiltersApplied="onFiltersApplied"/>
      </agro-filter-container>
    </card>
    <div class="content-body pt-4">
      <div class="row">
        <div class="col-lg-12">
          <agro-grid
            :headers="headers"
            :rows="items"
            :paginate="true"
            :permission="config"
            :action="onPageSelected"
            :loading="loading"
          >
          </agro-grid>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as type from '../../../store/mutation-types'
import AgroGrid from "@/components/AgroGrid/index";
import {canDelete, canEdit, permissions, permissionTypes} from "@/helpers/Permissions";
import SCShiftFilters from "@/pages/salary-calculator/sc-shift/partials/SCShiftFilters";
import {days} from "@/helpers/dateHelper";
import Forbidden from "~/pages/errors/Forbidden.vue";
import AgroFilterContainer from "@/components/AgroFilter/partials/AgroFilterContainer.vue";

export default {
  name: 'SCShiftList',
  middleware: ['auth', 'check-company-admin'],
  data() {
    return {
      currentPage: 1,
      filters: this.scShiftFilters ? this.scShiftFilters : {},
      items: this.scShifts ? this.scShifts : [],
      pager: this.pagination ? this.pagination : {},
      loading: false,
    }
  },
  components: {
    AgroFilterContainer,
    Forbidden,
    SCShiftFilters,
    AgroGrid,
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      scShiftFilters: 'scShift/scShiftFilters',
      scShifts: 'scShift/scShifts',
      pagination: 'common/pagination',
      users: 'user/users',
    }),
    title() {
      return this.$t('common.shift');
    },
    config() {
      return {
        permission: permissions.SC_EMPLOYEE,
        permission_type: permissionTypes.module,
        edit: {
          url: '/salary-calculator/sc-shift/{uuid}',
          callback: this.onItemEdited,
        },
        delete: {
          method: this.deleteObject,
          callback: this.onItemDeleted,
        }
      };
    },
    canEdit() {
      return canEdit(this);
    },
    canDelete() {
      return canDelete(this);
    },
    headers() {
      return  [
        { name: this.$t('common.name'), col: 'name', width: '25%' },
        { name: this.$t('salary_calculator.shift.day'), col: 'day_text', width: '10%' },
        { name: this.$t('salary_calculator.shift.start_hour'), col: 'start_hour', width: '10%' },
        { name: this.$t('salary_calculator.shift.end_hour'), col: 'end_hour', width: '10%' },
        { name: this.$t('common.created_at'), col: 'created_at', width: '20%' },
        { name: this.$t('common.last_update'), col: 'updated_at', width: '20%' },
      ];
    },
  },
  methods: {
    ...mapActions({
      deleteObject: 'scShift/deleteSCShift',
    }),
    onPageSelected(page_id) {
      this.filters.page = page_id;
      this.$store.commit("scShift/"+type.SET_SC_SHIFT_FILTERS, this.filters);
      this.$refs.filters.applyFilters();
    },
    newObject() {
      this.$router.push({
        path: 'sc-shift/add'
      });
    },
    onItemEdited(item) {
      console.log('onItemEdited', item);
    },
    onItemDeleted(item) {
      console.log('onItemDeleted', item);
    },
    onFiltersApplied(filters) {
      this.loading = true;
    },
    replaceDay(cell) {
        return days[this.$i18n.locale][cell.day];
    }
  },
  watch: {
    scShifts: {
      handler: function(newVal) {
        this.items = newVal;
      },
      deep: true,
    },
    pagination: {
      handler: function(newVal) {
        this.pager = newVal;
      },
      deep: true,
    },
  }
}
</script>

<style scoped>

</style>
